import {FunctionComponent}                     from "react";
import React                                   from "react";
import {Link}                                  from "react-router-dom";
import styled                                  from "styled-components";
import CloseIcon                               from "../../assets/icons/close.svg";
import {defaultSecondaryButtonIconRightStyles} from "../../styles/DefaultSecondaryButtonIconRightStyles";
import {ButtonType}                            from "../../types/ButtonType";


const StyledButton = styled.button`
    ${defaultSecondaryButtonIconRightStyles};
    background-image: url(${CloseIcon});
    background-size: 10px;
`;

const StyledLink = styled(Link)`
    ${defaultSecondaryButtonIconRightStyles};
    background-image: url(${CloseIcon});
    background-size: 10px;

`;

const StyledHref = styled.a`
    ${defaultSecondaryButtonIconRightStyles};
    background-image: url(${CloseIcon});
    background-size: 10px;
`;


const ButtonSecondaryClose: FunctionComponent<ButtonType> = (props) => {

  const RenderButton = (props: any) => {
    if (props.to) {
      return <StyledLink to={props.to} {...props}>{props.children}</StyledLink>;
    } else if (props.href) {
      return <StyledHref href={props.href} {...props}>{props.children}</StyledHref>;
    } else {
      return <StyledButton type={props.type} {...props}>{props.children}</StyledButton>;
    }
  };

  return (
    <>
      {
        RenderButton(props)
      }
    </>
  );
};

StyledButton.defaultProps = {
  type: "button",
};

export default ButtonSecondaryClose;
